{
  "hero.title": "Переключатель окружений для нескольких CLI",
  "hero.tagline-1": "войдите в состояние дзен-потока при программировании.",
  "hero.tagline-2": "плавное переключение окружений.",
  "hero.subtitle": "Единое управление конфигурациями Claude Code, Codex и OpenCode с автоматическим переключением API-прокси",
  "hero.getDocs": "Документация",
  "features.title": "Возможности",
  "features.multiCli.title": "Поддержка нескольких CLI",
  "features.multiCli.desc": "Claude Code, Codex и OpenCode с настройкой для каждого проекта",
  "features.multiConfig.title": "Управление конфигурацией",
  "features.multiConfig.desc": "Все настройки API-провайдеров в одном JSON-файле",
  "features.daemon.title": "Единый демон",
  "features.daemon.desc": "Один процесс zend поднимает и прокси-сервер, и веб-интерфейс",
  "features.failover.title": "Отказоустойчивый прокси",
  "features.failover.desc": "Встроенный HTTP-прокси с автоматическим переключением, когда основной провайдер недоступен",
  "features.routing.title": "Маршрутизация по сценариям",
  "features.routing.desc": "Умная маршрутизация по признакам запроса (размышление, изображение и т. д.)",
  "features.binding.title": "Привязка проектов",
  "features.binding.desc": "Привязывайте каталоги к профилям и CLI для автоматической настройки на уровне проекта",
  "features.envVars.title": "Переменные окружения",
  "features.envVars.desc": "Задавайте переменные окружения для каждой CLI на уровне провайдера",
  "features.webUi.title": "Веб-интерфейс",
  "features.webUi.desc": "Визуальное управление в браузере с защитой паролем",
  "features.webSecurity.title": "Безопасность веб-интерфейса",
  "features.webSecurity.desc": "Автоматически созданный пароль, сессионная аутентификация, RSA-шифрование при передаче токенов",
  "features.configSync.title": "Синхронизация конфигурации",
  "features.configSync.desc": "Синхронизация провайдеров, профилей и настроек между устройствами с шифрованием AES-256-GCM",
  "features.comingSoon": "Скоро появятся новые возможности, следите за обновлениями!",
  "install.title": "Быстрый старт",
  "install.step1.title": "Установить GoZen",
  "install.step1.desc": "Установка одной строкой",
  "install.step2.title": "Настроить провайдера",
  "install.step2.desc": "Добавьте первого API-провайдера",
  "install.step3.title": "Запустить",
  "install.step3.desc": "Запустите CLI с конфигурацией по умолчанию",
  "commands.title": "Команды",
  "commands.command": "Команда",
  "commands.description": "Описание",
  "commands.items.start": "Запустить CLI (по привязке проекта или конфигурации по умолчанию)",
  "commands.items.profile": "Запустить с указанным профилем",
  "commands.items.profilePick": "Выбрать профиль интерактивно",
  "commands.items.cli": "Использовать указанную CLI (claude/codex/opencode)",
  "commands.items.yes": "Автоматически подтверждать разрешения CLI (claude --permission-mode acceptEdits, codex -a never)",
  "commands.items.use": "Использовать указанного провайдера напрямую (без прокси)",
  "commands.items.pick": "Выбрать провайдера интерактивно",
  "commands.items.list": "Показать всех провайдеров и все профили",
  "commands.items.configAddProvider": "Добавить провайдера",
  "commands.items.configAddProfile": "Добавить профиль",
  "commands.items.configDefaultClient": "Задать CLI-клиент по умолчанию",
  "commands.items.configDefaultProfile": "Задать профиль по умолчанию",
  "commands.items.configResetPassword": "Сбросить пароль веб-интерфейса",
  "commands.items.configSync": "Получить конфигурацию из удалённого хранилища",
  "commands.items.daemonStart": "Запустить демон zend",
  "commands.items.daemonStop": "Остановить демон",
  "commands.items.daemonStatus": "Показать состояние демона",
  "commands.items.daemonEnable": "Установить демон как системную службу",
  "commands.items.daemonDisable": "Удалить системную службу демона",
  "commands.items.bind": "Привязать текущий каталог к профилю",
  "commands.items.bindCli": "Привязать текущий каталог к указанной CLI",
  "commands.items.unbind": "Отвязать текущий каталог",
  "commands.items.status": "Показать привязку текущего каталога",
  "commands.items.web": "Открыть веб-интерфейс в браузере (запускает демон)",
  "commands.items.upgrade": "Обновить до последней версии",
  "commands.items.version": "Показать версию",
  "commands.items.completion": "Сгенерировать автодополнение оболочки (zsh/bash/fish)",
  "homepage.title": "Переключатель окружений для нескольких CLI"
}
